import {FC} from 'react'
import {Routes, Route} from 'react-router-dom'
import Fulfillment from './fulfillment/Fulfillment'
import Shipping from './shippingService/ShippingService'
import ManualShipping from './manualShipping/ManualShipping'

const FulfillmentPage: FC = () => {
  return (
    <Routes>
      <Route index path='view' element={<Fulfillment />} />
      <Route path='manual' element={<ManualShipping />} />
      <Route path='shipping' element={<Shipping />} />
    </Routes>
  )
}

export default FulfillmentPage
